<template>
    <div class="form-item" v-show="item.visible">
        <el-tooltip class="item" effect="dark" placement="top-start" v-if="item.description">
            <div slot="content">
                {{item.description}}
            </div>
            <img class="form-tooltip" :src="require('@/assets/question.png')"/>
        </el-tooltip>
        <el-form-item :label="item.label" :prop="item.prop" :rules="rules">
            <el-select v-model="itemdata" placeholder="Please choose" :disabled="!item.editable">
                <el-option v-for="option in item.options" :key="option.value" :label="option.label" :value="option.value">
                </el-option>
            </el-select>
            <br>
            <span v-if="!itemdata" class="prompt">{{item.prompt}}</span>
        </el-form-item>
    </div>
</template>


<script>
import utils from '@/utils'

export default {
	name: 'select-widget',
	props: {
		editable: { type: Boolean },
		item: { type: Object },
		value: [String, Array ]
	},
	data() {
		return {
			rules: utils.generateFormRule(this.item)
		}
	},
	computed: {
		itemdata: {
			get() { return this.value },
			set(itemdata) { this.$emit('input', itemdata) }
		}
	},
	created() {
		if (this.value != undefined) {
			if (typeof(this.value) == 'string' && this.value.length > 0) {
				this.itemdata = this.value
			}else{
				this.itemdata = this.item.defaultValue
			}
			
		}else{
			this.itemdata = this.item.defaultValue
		}
	}
}
</script>
